import * as React from "react";
import { Route, Routes } from "react-router";
import Helmet from "react-helmet";
import AppRoutes from "../../../AppRoutes";
import { Loading } from "@commonComponents/ui/Loading";
import PageNotFound from "./PageNotFound";

const HomePage = React.lazy(() => import(/* webpackChunkName: "HomePage" */ "./home/HomePage"));
const PricingPage = React.lazy(() => import(/* webpackChunkName: "PricingPage" */ "./pricing/PricingPage"));

const InvitationLinkPage = React.lazy(
    () => import(/* webpackChunkName: "Invitations" */ "./invitations/InvitationLinkPage")
);

const LoginWithRecoveryCodePage = React.lazy(
    () => import(/* webpackChunkName: "Users" */ "./users/LoginWithRecoveryCodePage")
);
const LoginWith2faPage = React.lazy(() => import(/* webpackChunkName: "Users" */ "./users/LoginWith2faPage"));
const LoginPage = React.lazy(() => import(/* webpackChunkName: "Users" */ "./users/LoginPage"));
const LoginLinkPage = React.lazy(() => import(/* webpackChunkName: "Users" */ "./users/LoginLinkPage"));
const InvitationPage = React.lazy(() => import(/* webpackChunkName: "Users" */ "./users/InvitationPage"));
const LogoutPage = React.lazy(() => import(/* webpackChunkName: "Users" */ "./users/LogoutPage"));

const RegistrationThankYou = React.lazy(
    () => import(/* webpackChunkName: "Registration" */ "./users/registrationPage/RegistrationPageThankYou")
);
const RegistrationThankYouUserAlreadyExists = React.lazy(
    () => import(/* webpackChunkName: "Registration" */ "./users/registrationPage/RegistrationPageEmailAlreadyExist")
);
const RegistrationPage = React.lazy(
    () => import(/* webpackChunkName: "Registration" */ "./users/registrationPage/RegistrationPage")
);

export function PublicComponent() {
    return (
        <div className="front">
            <Helmet>
                <title>Managed RavenDB Cloud Hosting | RavenDB NoSQL</title>
                <meta
                    name="description"
                    content="Managed RavenDB Cloud Hosting - a fully managed cloud: enjoy database hosting, management and backups all in one place."
                />
            </Helmet>
            <React.Suspense fallback={<Loading />}>
                <Routes>
                    <Route path={AppRoutes.forHomePage().linkForRoute} element={<HomePage />} />
                    <Route path={AppRoutes.forPricing().linkForRoute} element={<PricingPage />} />
                    <Route
                        path={AppRoutes.forUserLoginWithRecoveryCode().linkForRoute}
                        element={<LoginWithRecoveryCodePage />}
                    />
                    <Route path={AppRoutes.forUserLoginWith2fa().linkForRoute} element={<LoginWith2faPage />} />
                    <Route path={AppRoutes.forUserLoginLink().linkForRoute} element={<LoginLinkPage />} />
                    <Route path={AppRoutes.forUserLogin().linkForRoute} element={<LoginPage />} />
                    <Route path={AppRoutes.forInvitation().linkForRoute} element={<InvitationPage />} />
                    <Route path={AppRoutes.forInvitationLink().linkForRoute} element={<InvitationLinkPage />} />
                    <Route path={AppRoutes.forUserLogout().linkForRoute} element={<LogoutPage />} />
                    <Route path={AppRoutes.forRegistrationThankYou().linkForRoute} element={<RegistrationThankYou />} />
                    <Route
                        path={AppRoutes.forRegistrationThankYouUserAlreadyExists().linkForRoute}
                        element={<RegistrationThankYouUserAlreadyExists />}
                    />
                    <Route path={AppRoutes.forUserRegistration().linkForRoute} element={<RegistrationPage />} />
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </React.Suspense>
        </div>
    );
}

export function Public() {
    return <PublicComponent />;
}
